const IllustrationFokus = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 475 300"
    xmlSpace="preserve"
  >
    <style>
      {
        '.st1{fill:#4c3e7a}.st2{fill:#a59ebc}.st6{fill:#dbd8e4}.st7{fill:none;stroke:#716595;stroke-width:1.25;stroke-miterlimit:10}.st10{fill:#fff}'
      }
    </style>
    <path
      d="M357.1 214.65c-1.13 1.71-3.04 4.86-5.22 7.82-2.26 3.07-4.65 6.07-7.21 8.91-2.62 2.91-5.5 5.59-8.29 8.34-2.33 2.3-4.68 4.57-7.06 6.82-1.24 1.17-2.57 2.25-3.87 3.36-2.18 1.85-4.33 3.75-6.56 5.54-2.26 1.8-4.59 3.53-6.93 5.24-2.13 1.56-4.28 3.1-6.49 4.55-1.83 1.2-3.74 2.29-5.65 3.39-2.28 1.31-4.56 2.6-6.89 3.83-2.4 1.26-4.83 2.48-7.29 3.63-2.64 1.23-5.3 2.45-8.02 3.51-4.05 1.58-8.13 3.1-12.26 4.52-5.73 1.96-11.59 3.54-17.56 4.72-4.56.9-9.14 1.76-13.75 2.39-3.93.53-7.91.77-11.88 1.03-9.65.65-19.3.22-28.96-1.03-9.43-1.22-18.68-3.38-27.67-6.56-4.42-1.57-8.75-3.43-13.04-5.35a88.077 88.077 0 0 1-13.66-7.6c-3.61-2.46-7.3-4.83-10.72-7.52-3.45-2.71-6.64-5.76-9.89-8.7-4.5-4.08-8.33-8.74-12.04-13.47-2.04-2.6-3.91-5.36-5.67-8.15-2.1-3.34-4.13-6.72-5.92-10.21a75.956 75.956 0 0 1-5.45-13.87c-1.08-3.78-1.86-7.61-2.26-11.51-.71-6.92-.05-13.66 2.1-20.19 1.26-3.83 3.06-7.41 5.24-10.79 2.9-4.49 6.36-8.55 9.97-12.49 2.65-2.88 5.43-5.65 8.11-8.51 2.43-2.59 4.86-5.19 7.18-7.87 1.48-1.71 2.79-3.55 4.13-5.37 1.4-1.91 2.79-3.83 4.09-5.8 1.34-2.03 2.58-4.12 3.84-6.19 1.2-1.98 2.38-3.96 3.55-5.95 1.1-1.87 2.17-3.76 3.26-5.64l4.32-7.44c1.09-1.88 2.15-3.78 3.28-5.63 1.67-2.73 3.34-5.47 5.1-8.14 1.68-2.56 3.43-5.08 5.22-7.57 1.12-1.56 2.35-3.05 3.56-4.55s2.42-3 3.72-4.42c2.19-2.4 4.41-4.76 6.69-7.08 2.29-2.33 4.57-4.69 7.05-6.83 2.8-2.42 5.77-4.66 8.73-6.89 2.65-2 5.33-3.95 8.09-5.8 2.36-1.59 4.82-3.04 7.28-4.48 2.46-1.44 4.94-2.83 7.46-4.16 1.98-1.04 4-2 6.04-2.91 2.8-1.24 5.62-2.45 8.47-3.58 2.38-.94 4.81-1.76 7.23-2.62 6.68-2.37 13.55-4.13 20.53-5.55 5.94-1.21 11.93-2.15 18-2.63 6.77-.54 13.57-.56 20.38.17 6.58.7 13.05 2.03 19.31 4.29 5.2 1.88 10.15 4.32 14.68 7.54 3.68 2.6 7.04 5.51 9.99 8.91 4.7 5.41 8.22 11.43 10.75 17.98 1.99 5.15 3.55 10.43 4.54 15.82.92 5.01 1.76 10.04 2.55 15.07.72 4.59 1.34 9.18 1.97 13.77.92 6.64 1.83 13.28 2.72 19.93 1.06 7.88 2.05 15.76 3.14 23.64.76 5.46 1.78 10.9 2.46 16.37.73 5.8 1.35 11.61 1.73 17.43.25 3.87.1 7.77-.07 11.64-.18 4.07-.93 8.06-1.93 12-.81 3.24-2.12 6.34-4.25 10.89"
      style={{
        fill: '#f2d400',
      }}
      id="form"
    />
    <g id="ill">
      <path
        className="st1"
        d="M320.42 158.39c27.59 25.55 26.7 92.86-18.8 83.51l18.8-83.51z"
      />
      <path
        className="st2"
        d="M281.94 201.16c4.05 22.81.61 25.27-2.69 26.09-2.15.53-5.59.37-9.9-13.52l-2.92-10.77"
      />
      <path
        className="st2"
        d="M272.59 198.25c-2.35 25.08-6.67 26.67-10.36 26.56-2.4-.07-5.96-1.22-6.46-17.04l.06-12.13"
      />
      <defs>
        <path
          id="SVGID_1_"
          d="M281.94 201.16c4.05 22.81.61 25.27-2.69 26.09-2.15.53-5.59.37-9.9-13.52l-2.92-10.77 15.51-1.8z"
        />
      </defs>
      <clipPath id="SVGID_00000160900190983158197020000002743246356147685559_">
        <use
          xlinkHref="#SVGID_1_"
          style={{
            overflow: 'visible',
          }}
        />
      </clipPath>
      <path
        style={{
          clipPath:
            'url(#SVGID_00000160900190983158197020000002743246356147685559_)',
          fill: 'none',
          stroke: '#716595',
          strokeWidth: 1.25,
          strokeMiterlimit: 10,
        }}
        d="M272.59 198.25c-2.35 25.08-6.67 26.67-10.36 26.56"
      />
      <path
        className="st2"
        d="M260.43 190.86c-4.67 20.19-8.21 25.88-12.26 26.51-2.65.42-7.13-2.09-5.78-17.85l1.25-10.64"
      />
      <defs>
        <path
          id="SVGID_00000124882466874813775690000010318270852008214458_"
          d="M272.59 198.25c-2.35 25.08-6.67 26.67-10.36 26.56-2.4-.07-5.96-1.22-6.46-17.04l.06-12.13 16.76 2.61z"
        />
      </defs>
      <clipPath id="SVGID_00000089572095874424944940000010924562488748107415_">
        <use
          xlinkHref="#SVGID_00000124882466874813775690000010318270852008214458_"
          style={{
            overflow: 'visible',
          }}
        />
      </clipPath>
      <path
        style={{
          clipPath:
            'url(#SVGID_00000089572095874424944940000010924562488748107415_)',
          fill: 'none',
          stroke: '#716595',
          strokeWidth: 1.25,
          strokeMiterlimit: 10,
        }}
        d="M260.43 190.86c-4.67 20.19-8.21 25.88-12.26 26.51"
      />
      <path
        className="st2"
        d="M247.21 186c-4.52 18.05-8.28 22.47-12.9 21.87-2.06-.26-7.5-.95-4.67-23.02"
      />
      <defs>
        <path
          id="SVGID_00000094604792223050177320000013220358755070050737_"
          d="M260.43 190.86c-4.67 20.19-8.21 25.88-12.26 26.51-2.65.42-7.13-2.09-5.78-17.85l1.25-10.64 16.79 1.98z"
        />
      </defs>
      <clipPath id="SVGID_00000049928753030883805410000015051586496969323398_">
        <use
          xlinkHref="#SVGID_00000094604792223050177320000013220358755070050737_"
          style={{
            overflow: 'visible',
          }}
        />
      </clipPath>
      <path
        style={{
          clipPath:
            'url(#SVGID_00000049928753030883805410000015051586496969323398_)',
          fill: 'none',
          stroke: '#716595',
          strokeWidth: 1.25,
          strokeMiterlimit: 10,
        }}
        d="M247.21 186c-4.52 18.05-8.28 22.47-12.9 21.87"
      />
      <path
        className="st6"
        d="M234.74 167.52c77.11-21.36 64.28-10.27 95.94 23.35l12.38 30.66c-20.38 12.19-32.79 12.35-38.31 11.42-11.52-1.94-20.74-10.29-26.58-23.62l-43.43-41.81z"
      />
      <path
        className="st2"
        d="m279.65 195.15-6.75-20.37-17.09 3.42 3.28 8.44z"
      />
      <path className="st7" d="m272.9 174.78-17.09 3.42" />
      <path
        style={{
          fill: '#716595',
        }}
        d="m262.5 201.16-107.43-63.09 11.99-7.93 114.01 56.95z"
      />
      <circle className="st1" cx={161.23} cy={133.32} r={73.04} />
      <circle className="st6" cx={161.23} cy={133.32} r={60.85} />
      <defs>
        <circle
          id="SVGID_00000146490614923367585280000008742544554265133226_"
          cx={161.23}
          cy={133.32}
          r={60.85}
        />
      </defs>
      <clipPath id="SVGID_00000047771191774493033740000000077714764998665600_">
        <use
          xlinkHref="#SVGID_00000146490614923367585280000008742544554265133226_"
          style={{
            overflow: 'visible',
          }}
        />
      </clipPath>
      <g
        style={{
          clipPath:
            'url(#SVGID_00000047771191774493033740000000077714764998665600_)',
        }}
      >
        <path
          className="st10"
          d="M92.14 132.73c44.53 41.39 90.58 44.65 138.17 0M230.31 132.73c-20.34-24.44-86.62-55.53-138.17 0"
        />
      </g>
      <path
        style={{
          clipPath:
            'url(#SVGID_00000047771191774493033740000000077714764998665600_)',
          fill: '#15958c',
        }}
        d="M166.43 101.94c-18.45-2.73-37.84 16.44-34.96 36.03 2.4 16.38 19.93 30.06 37.13 25.93 14.75-3.55 23.72-18.86 22.58-33.28-1.1-13.85-11.52-26.73-24.75-28.68z"
      />
      <path
        style={{
          clipPath:
            'url(#SVGID_00000047771191774493033740000000077714764998665600_)',
          fill: '#4c3e7a',
        }}
        d="M161.42 146c-6.9 0-12.5-5.6-12.5-12.5s5.6-12.5 12.5-12.5c6.91 0 12.51 5.6 12.51 12.5s-5.6 12.5-12.51 12.5z"
      />
      <path
        d="M182.4 90.95c14.63 7.31 23.82 21.16 25.81 36.24"
        style={{
          fill: 'none',
          stroke: '#eff1f9',
          strokeWidth: 1.25,
          strokeMiterlimit: 10,
        }}
      />
      <path
        d="m341.85 266.59 29.27-85.37-50.71-22.84c7.74 49.63 20.5 83.85-18.8 83.51l40.24 24.7z"
        style={{
          fill: '#15958c',
        }}
      />
      <path
        className="st6"
        d="M293.95 191.19c-3.16-.79-45.81-16.64-61.64-17.05-2.55-.06-4.87 1.45-5.93 3.77-1.1 2.42-.63 5.28 1.25 7.15 8.64 8.6 34.54 17.87 58.39 27.4"
      />
      <path
        className="st7"
        d="M243.78 181.83c-1.23-.99-2.79-1.89-4.56-2.58-5.1-1.97-10.06-1.43-11.08 1.21s2.28 6.38 7.38 8.35c1.68.65 3.35 1.03 4.86 1.15l3.4-8.13z"
      />
      <path
        d="M301.61 232.25c-10.07-2.82-18.16-10.82-23.46-22.92"
        style={{
          fill: 'none',
          stroke: '#948baf',
          strokeWidth: 1.25,
          strokeMiterlimit: 10,
        }}
      />
      <defs>
        <path
          id="SVGID_00000152234270490520067050000016172947407398221192_"
          d="M228.89 197.73c-.14-3.17.05-7.35.76-12.87l64.3 23.07c-.88 3.5-3.49 5.67-7.16 6.88l-57.9-17.08z"
        />
      </defs>
      <clipPath id="SVGID_00000018223016833223332580000008097780667398512782_">
        <use
          xlinkHref="#SVGID_00000152234270490520067050000016172947407398221192_"
          style={{
            overflow: 'visible',
          }}
        />
      </clipPath>
      <path
        style={{
          clipPath:
            'url(#SVGID_00000018223016833223332580000008097780667398512782_)',
          fill: 'none',
          stroke: '#716595',
          strokeWidth: 1.25,
          strokeMiterlimit: 10,
        }}
        d="M227.63 185.07c8.64 8.6 34.54 17.87 58.39 27.4"
      />
      <path
        transform="rotate(-17.64 285.712 186.895)"
        className="st6"
        d="M277.43 170.65h16.52v32.5h-16.52z"
      />
    </g>
  </svg>
)

export default IllustrationFokus
